import { format } from "date-fns";

export function formatDate(date: Date): string {
  return format(date, "yyyy MMM dd");
}

export function formatTime(date: Date): string {
  return format(date, "yyyy MMM dd - HH:mm");
}
